import { render, staticRenderFns } from "./data-ready.vue?vue&type=template&id=24936c64&"
import script from "./data-ready.vue?vue&type=script&lang=js&"
export * from "./data-ready.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports